import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpFloorPlanDevices} from '@features/floor-plan/http/floorPlan.http.ts'
import {parseAxiosPromise} from '@/axiosInstance'
import {captureException} from '@sentry/react'
import {FloorPlanDevice} from '../types'
import {z} from 'zod'

export const useFloorPlanDevices = () =>
    useQuery({
        queryKey: [QUERY_KEYS.FLOOR_PLAN_DEVICES],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpFloorPlanDevices(),
                responseShape: z.array(FloorPlanDevice),
                onZodError: captureException
            })
    })
